import React, { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { CheckCircle } from "lucide-react";
import { Button } from "../components/ui/button";

const LOGO_URL = "https://customer-assets.emergentagent.com/job_b01f443b-34d5-4fc7-9e0b-ca007ef072d9/artifacts/tahd0sec_IMG_0935.jpeg";

export default function SuccessPage() {
  const navigate = useNavigate();
  const location = useLocation();
  const user = location.state?.user;

  useEffect(() => {
    // Auto redirect after 3 seconds
    const timer = setTimeout(() => {
      navigate("/home");
    }, 3000);

    return () => clearTimeout(timer);
  }, [navigate]);

  return (
    <div 
      className="min-h-screen flex flex-col items-center justify-center px-6 bg-white"
      data-testid="success-page"
    >
      {/* Success Icon */}
      <div className="mb-8 animate-scale-in">
        <div className="w-20 h-20 bg-golf-green/10 rounded-full flex items-center justify-center">
          <CheckCircle className="w-10 h-10 text-golf-green" />
        </div>
      </div>

      {/* Logo */}
      <div className="mb-8 animate-fade-in" style={{ animationDelay: '0.1s' }}>
        <img 
          src={LOGO_URL} 
          alt="ZD Golf" 
          className="w-32 h-auto"
        />
      </div>

      {/* Welcome Text */}
      <div className="text-center mb-12 animate-slide-up" style={{ animationDelay: '0.2s' }}>
        <h1 className="font-heading text-3xl font-bold text-black mb-3">
          Добро пожаловать
        </h1>
        <h2 className="font-heading text-2xl font-semibold text-golf-green mb-4">
          в ZD GOLF APP
        </h2>
        {user && (
          <p className="text-apple-text-secondary text-lg">
            {user.first_name} {user.last_name}
          </p>
        )}
      </div>

      {/* Continue Button */}
      <Button
        onClick={() => navigate("/home")}
        className="w-full max-w-sm h-14 bg-golf-green hover:bg-golf-green-hover text-white rounded-full text-lg font-semibold animate-slide-up"
        style={{ animationDelay: '0.3s' }}
        data-testid="continue-btn"
      >
        Продолжить
      </Button>
    </div>
  );
}
